/**
 * EU-SCRIPTS
 * ============
 *
 * This is the main Javascript bundle for the US website.
 */

//1. index.js is from Vshift -- do not modify this path.
require("./sources/index.js");

//2. Overrides from VanEck
require('./override/index.js');

//3. Script from the landing pages
require('./landing-pages/index.js')

require('./funds/performance-past-years-chart');
